<template>
	<div class="home_main">
		<div class="title">
			<div class="box1">
				<!-- <img src="../img/home/text1.png"> -->
				<span>主界面</span>
			</div>
			<!-- <div class="box1" v-if="version == 1">
				<h1></h1>
			</div> -->
			<div class="box2">
				<span class="line line1"></span>
				<span class="text2">Main interface</span>
				<span class="line line2"></span>
			</div>
		</div>
		<div class="nav_box" :class="{'nav_box_EN':version==1}">
			<router-link :to="item.routerLink" tag="div" class="nav_li" v-for="(item,index) in navLsit" :key="index" v-if="version == 0">
					<img :src="item.imgUrl">
					<div class="text1"><span>{{item.name}}</span></div>
					<div class="text2"><span>{{item.title}}</span></div>
			</router-link>
			<router-link :to="item.routerLink" tag="div" class="nav_li nav_li_EN" v-for="(item,index) in navLsitEN" :key="index" v-if="version == 1">
					<img :src="item.imgUrl">
					<div class="text1"><span>{{item.name}}</span></div>
					<div class="text2"><span>{{item.title}}</span></div>
			</router-link>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	import baseApi from '../api/base.js'
    import allUrl from '../api/allUel.js'
    import projectSummary from '../img/home/projectSummary.png'
    import projectManagement from '../img/home/projectManagement.png'
    import videoSurveillance from '../img/home/videoSurveillance.png'
    import weatherMonitor from '../img/home/weatherMonitor.png'
    import GIS from '../img/home/GIS.png'
    import alarmMaintenance from '../img/home/alarmMaintenance.png'
    import historicalData from '../img/home/historicalData.png'
    import userManagement from '../img/home/userManagement.png'
    import operationLog from '../img/home/operationLog.png'
    import strategy from '../img/home/strategy.png'

	export default{
        data() {
        	return {
        		navLsit:[
	        		{name:'项目概要',title:'显示您大概的项目情况，实时数据，项目编辑，权限分配；管理项目电网与路灯的属性关联',routerLink:'projectSummary',imgUrl:projectSummary},
	        		{name:'项目管理',title:'根据项目分类查看管理您的设备及其设置，灵活利用分组策略进行统一化操控。',routerLink:'projectManagement',imgUrl:projectManagement},
	        		{name:'策略设置',title:'策略设置可以是您更加快捷统一的管理您的设备群，根据不同的参数匹配，让您的工作更加简单。',routerLink:'strategy',imgUrl:strategy},
	        		{name:'视频监控',title:'展示所有监控视频，实时同步查看，清晰度、探头方向皆可灵活控制。',routerLink:'videoSurveillance',imgUrl:videoSurveillance},
	        		{name:'天气监控',title:'设备只能探测周边环境信息，多层协助亮度设置，让灯控设备更加贴近生活需求。',routerLink:'weatherMonitor',imgUrl:weatherMonitor},
	        		{name:'GIS地图',title:'GIS地图全面展示旗下灯控，根据不同设备类型、状态区分显示，方便用户快捷查看操作。',routerLink:'GISMap',imgUrl:GIS},
	        		{name:'告警维修',title:'及时提醒设备损耗状态，实时同步设备维修情况；快捷管理维修人员基础信息及工作历史。',routerLink:'alarmMaintenance',imgUrl:alarmMaintenance},
	        		{name:'历史数据',title:'通过多元化图表展示数据走势，灵活进行设备对比，让设备管理更加清晰，汇报工作更加简单。',routerLink:'historicalData',imgUrl:historicalData},
	        		{name:'用户管理',title:'查看您的基本个人信息及地域、权限信息，控制您的子账号各类权限。',routerLink:'userManagement',imgUrl:userManagement},
	        		{name:'操作日志',title:'实时展示平台账户操作相关，关键字查询、分类搜索、快捷溯源，让您的操作有迹可循。',routerLink:'operationLog',imgUrl:operationLog},
        		],
        		navLsitEN:[
	        		{name:'Project Summary',title:'Display your general project situation, real-time data, project editing, privilege allocation; manage the attribute association between the project grid and street lights',routerLink:'projectSummary',imgUrl:projectSummary},
	        		{name:'project management',title:'View and manage your equipment and its settings according to project classification, and use group strategy flexibly for unified control.',routerLink:'projectManagement',imgUrl:projectManagement},
	        		{name:'Policy Settings',title:'Policy settings can help you manage your device cluster more quickly and uniformly, and match different parameters to make your work easier.',routerLink:'strategy',imgUrl:strategy},
	        		{name:'Video surveillance',title:'Display all surveillance videos, real-time synchronous viewing, sharpness, probe direction can be flexibly controlled.',routerLink:'videoSurveillance',imgUrl:videoSurveillance},
	        		{name:'Weather monitoring',title:'Equipment can only detect the surrounding environment information, multi-level assistance brightness settings, so that the lighting control equipment closer to the needs of life.',routerLink:'weatherMonitor',imgUrl:weatherMonitor},
	        		{name:'GIS map',title:'GIS maps fully display the lighting control under the flag, and display it differently according to different equipment types and states, which is convenient for users to view and operate quickly.',routerLink:'GISMap',imgUrl:GIS},
	        		{name:'Alarm maintenance',title:'Remind equipment wear and tear status in time, synchronize equipment maintenance status in real time, and quickly manage basic information and work history of maintenance personnel.',routerLink:'alarmMaintenance',imgUrl:alarmMaintenance},
	        		{name:'historical data',title:'By displaying data trends through diversified charts and flexible equipment comparison, equipment management is clearer and reporting is simpler.',routerLink:'historicalData',imgUrl:historicalData},
	        		{name:'user management',title:'View your basic personal information and geographic and permission information, and control all kinds of permissions of your sub-account.',routerLink:'userManagement',imgUrl:userManagement},
	        		{name:'Operation log',title:'Real-time display platform account operation related, keyword query, classification search, fast traceability, so that your operation can follow.',routerLink:'operationLog',imgUrl:operationLog},
        		],
        	}
        },
        computed:{
            ...mapGetters({
            	token:'token',
            	username:'username',
            	client_key:'client_key',
            	record:'record',
            	version:'version',
            	homeData:'homeData',
	      })
	    },
        mounted(){
        	var this_ = this;
        	if(this.username){
        		console.log(this.username,this.client_key,this.token,this.version)
	        	baseApi.ajax_post3(
					allUrl.home.homeWeb_info,
					{
						username:this.username,
						client_key:this.client_key,
						token:this.token,
						version:this.version,
					},
					{},
					data =>{
					},
				this)
        	}
        },
        methods:{
        	routerLink(type){
		    	window.location.href='#/'+type;
		    }
	    }
    }
</script>
<style type="text/css" lang="less">
	.home_main{
		min-width: 1260px;
		max-width: 1920px;
		height: calc(100% - 64px);
		padding-top: 64px;
		background:rgba(249,249,249,1);
		.title{
			text-align: center;
			background:rgba(249,249,249,1);
			.box1{
				height:37px;line-height:37px;
				font-size:26px;
				font-family:PingFangSC-Semibold;
				font-weight:600;
				color:rgba(51,51,51,1);
			}
			.box2{
				.line1{
					margin-right: 11px;
				}
				.line2{
					margin-left: 11px;
				}
				.line{
					display: inline-block;
					position: relative;
					width:60px;height:1px;
					background-color: #DFDFDF;
					top: -4px;
				}
				.text2{
					height:17px;
					line-height:17px;
					font-size:12px;
					font-family:PingFang-SC-Medium;
					font-weight:500;
					color:rgba(102,102,102,1);
				}
			}
		}
		.nav_box{
			margin-top: 77px;
			display: flex;
			flex-wrap: wrap;
			align-content: flex-start;
			width: calc(100% - 180px);
			padding: 0 90px;
			background:rgba(249,249,249,1);
			.nav_li{
				width: 20%;
				text-align: center;
				cursor: pointer;
				padding: 48px;
				border: 1px solid #fff;
				box-sizing: border-box;
				margin-bottom: 20px;
				img{
					height: 40px;
				}
				.text1{
					font-size:20px;
					font-family:PingFang-SC-Medium;
					font-weight:500;
					color:rgba(51,51,51,1);
				}
				.text2{
					// font-size: 16px;
				 //    font-family: PingFang-SC-Regular;
				 //    font-weight: 400;
				 //    color: #888;
					margin-top: 10px;
					font-size:16px;
					font-family:PingFang-SC-Medium;
					font-weight:500;
					color:rgba(153,153,153,1);
					line-height:17px;
				}
			}
			.nav_li_EN{
				// width: calc(20% - 34px);
				padding: 20px;
			}
			.nav_li:hover{
				background:rgba(255,255,255,1);
				box-shadow:0px 2px 6px 0px rgba(0,0,0,0.05);
				border-radius:2px;
				border:1px solid rgba(240,240,240,1);
			}
			.nav_li:nth-child(5n+1){
				margin-left: 0px;
			}
			.nav_li:nth-child(5n){
				margin-right:0px;
			}
		}
		.nav_box_EN{
			width: calc(100% - 200px);
			padding: 0 100px;
		}
	}
	@media screen and (max-width:1600px){
		.home_main{
			height: calc(100% - 65px);
			padding-top: 65px;
			.nav_box{
				margin-top: 42px;
				width: calc(100% - 120px);
				padding: 0 60px;
				.nav_li{
					// width: calc(20% - 60px);
					padding: 35.5px;
					margin-bottom: 10px;
					img{
						height: 35px;
					}
					.text1{
						font-size:18px;
					}
					.text2{
						font-size: 14px;
						margin-top: 10px;
					}
				}
				.nav_li_EN{
					// width: calc(20% - 26px);
					padding: 15px;
				}
				.nav_li:nth-child(5n+1){
					margin-left: 0px
				}
				.nav_li:nth-child(5n){
					margin-right: 0px
				}
			}
			.nav_box_EN{
				width: calc(100% - 160px);
				padding: 0 80px;
			}
		}
	}
	@media screen and (max-width:1300px){
		.home_main{
			height: calc(100% - 65px);
			padding-top: 65px;
			.nav_box{
				margin-top: 42px;
				width: calc(100% - 100px);
				padding: 0 50px;
				.nav_li{
					// width: calc(20% - 50px);
					padding: 29.25px;
					// margin-bottom: 
					img{
						height: 30px;
					}
					.text1{
						font-style: 16px;
					}
					.text2{
						font-size: 12px;
						margin-top: 10px;
					}
				}
				.nav_li_EN{
					// width: calc(20% - 18px);
					padding: 10px;
				}
				.nav_li:nth-child(5n+1){
					margin-left: 0px
				}
				.nav_li:nth-child(5n){
					margin-right: 0px
				}
			}
			.nav_box_EN{
				width: calc(100% - 80px);
				padding: 0 40px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/home.vue